import { makeAutoObservable } from 'mobx'
import { CategoryList, OwnedProduct } from '../common'
import RootStore from './root'
import { SingleSubStore } from './subStore'

export class CommonStore {
  rootStore: RootStore
  isShowTab = true
  listTab = ''

  // 유저 예치금 조회
  currentBalance = new SingleSubStore<{ balance: number }>(`/user/current/balance`)

  // 카테고리 목록 조회
  categoryList = new SingleSubStore<CategoryList>(`/product/categories/list`)

  // 보유한 프로덕트 정보 조회
  getOwnedProduct = new SingleSubStore<OwnedProduct>(
    (param?: Record<string, any>) => `/purchase/ownedProduct/${param?.productId}`,
  )

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  // 하단 tab 표시 여부 설정
  setShowTab = (isShowTab: boolean) => {
    this.isShowTab = isShowTab
  }

  setListTab = (listTab: string) => {
    this.listTab = listTab
  }
}
